export const allowedPayments = [
  {
    'binListInstallmentCheck': false,
    'blocked': false,
    'ccImageUrl': null,
    'disabled': null,
    'formName': 'addPaymentWithAddress',
    'id': 0,
    'installmentNumbers': null,
    'installmentsAllowed': false,
    'localizedName': 'Visa',
    'merchantId': null,
    'minimumInstallmentAmount': null,
    'ofsId': 'VISA',
    'paymentClass': 'CCARD',
    'processorCode': null,
    'simulateWhenNumberGT': null
  }
];
